import request from './request'

export const fetchCategory = (category_id) => {
    return new Promise((resolve, reject) => {
        request.get(`category/${category_id}`)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const loadCat = (path,lang) => {
    return new Promise((resolve, reject) => {
        request.get('cat',{
            params: {
                path: path,
                iso: lang
            }
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    });
}
export const loadSales = (lang)=>{
    return new Promise((resolve, reject) => {
        request.get('sales',{
            params: {
                iso: lang
            }
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    });
}
